import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

export default function LanguageSelector({ variant = 'default' }) {
  const { language, changeLanguage } = useLanguage();

  if (variant === 'compact') {
    return (
      <div className="inline-flex items-center gap-1 bg-stone-100 rounded-full p-1" data-testid="language-selector">
        <button
          onClick={() => changeLanguage('ca')}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
            language === 'ca'
              ? 'bg-orange-600 text-white'
              : 'text-stone-600 hover:text-stone-900'
          }`}
          data-testid="lang-ca-btn"
        >
          CA
        </button>
        <button
          onClick={() => changeLanguage('es')}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
            language === 'es'
              ? 'bg-orange-600 text-white'
              : 'text-stone-600 hover:text-stone-900'
          }`}
          data-testid="lang-es-btn"
        >
          ES
        </button>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-md border border-stone-200 rounded-full p-1 shadow-sm" data-testid="language-selector">
      <Globe size={14} className="text-stone-400 ml-2" />
      <button
        onClick={() => changeLanguage('ca')}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${
          language === 'ca'
            ? 'bg-orange-600 text-white'
            : 'text-stone-600 hover:text-stone-900'
        }`}
        data-testid="lang-ca-btn"
      >
        Català
      </button>
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${
          language === 'es'
            ? 'bg-orange-600 text-white'
            : 'text-stone-600 hover:text-stone-900'
        }`}
        data-testid="lang-es-btn"
      >
        Castellano
      </button>
    </div>
  );
}
